module.exports = __webpack_public_path__ + "img/stackslash-46.705490d9.jpg";